import { createContext } from 'react';

export type SplitViewState =
  | 'SideBySide'
  | 'TextPanelOverMap'
  | 'MapPanel'
  | 'NotVisible';

export const SplitViewContext = createContext<SplitViewState>('NotVisible');
